import { render, staticRenderFns } from "./TraceabilitySubHeader.vue?vue&type=template&id=3de6a3ce&scoped=true"
import script from "./TraceabilitySubHeader.vue?vue&type=script&lang=js"
export * from "./TraceabilitySubHeader.vue?vue&type=script&lang=js"
import style0 from "./TraceabilitySubHeader.vue?vue&type=style&index=0&id=3de6a3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de6a3ce",
  null
  
)

export default component.exports